import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export enum UserFlow {
  Business = 'business',
  Personal = 'personal',
}

export interface GlobalState {
  userFlow: UserFlow;
  isLoading: boolean;
  companySlug: string;
  canSwitchCountryList?: any[];
}

export interface GlobalActions {
  setUserFlow: (flow: UserFlow) => void;
  updateCompanySlug: (slug: string) => void;
  updateCanSwitchCountryList?: (list: any[]) => void;
}

export interface GlobalStore {
  state: GlobalState;
  actions: GlobalActions;
}

export const useGlobalStore = create<GlobalStore>()(
  immer((set, get) => ({
    state: {
      userFlow: UserFlow.Personal,
      isLoading: null,
      companySlug: '',
      canSwitchCountryList: [],
    },
    actions: {
      setUserFlow: (flow) => {
        set((store) => {
          store.state.userFlow = flow;
        });
      },
      updateCompanySlug: (companySlug) => {
        set((store) => {
          store.state.companySlug = companySlug;
        });
      },
      updateCanSwitchCountryList: (list) => {
        set((store) => {
          store.state.canSwitchCountryList = list;
        });
      },
    },
  }))
);
